<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style">
            <div class="card-body text-center">
                <div class="collapse" :class="{ 'show': isActive('quran') }">
                    <h2>Quran</h2>
                    <input class="mt-3 form-control w-50 mx-auto" placeholder="Pencarian" v-model="search">
                </div>
            </div>
        </div>

        <div class="card card-style mb-3 rounded-s">
            <div class="border border-blue-dark rounded-s overflow-hidden">
                <table class="table color-theme border-blue-dark mb-0">
                    <thead class="rounded-s bg-blue-dark border-l">
                        <tr class="color-white">
                            <th scope="col" style="width: 10%;" class="text-center"><h5 class="color-white font-15 mb-0">No</h5></th>
                            <th scope="col" class="text-center"><h5 class="color-white font-15 mb-0">Nama</h5></th>
                            <th scope="col" style="width: 10%;" class="text-center"><h5 class="color-white font-15 mb-0">Ayat</h5></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in surahs" :key="item.id">
                            <td class="text-center">{{ item.no }}</td>
                            <td class="text-center">
                                    <router-link :to="{ name: 'quran.detail', params: {
                                        id: item.id,
                                        title: item.name
                                    } }">
                                    {{ item.name }}
                                </router-link>
                            </td>
                            <td class="text-center">{{ item.ayat_count }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="next_page_url" class="text-center mb-3">
            <button @click="loadMoreSurah()" class="btn gradient-highlight">Load More</button>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Home',
    data() {
        return {
            search: '',
            isBusy: false,
            activeTab: 'quran',
            pageAyat: 1,
        }
    },
    created() {
        this.getSurah()
        this.getPerAyat();
        this.getPerKata();
    },
    methods: {
        ...mapActions('quran', ['getSurah', 'getSurahLoadMore', 'getPerAyat', 'getPerKata']),
        loadMoreSurah() {
            let next_page = parseInt(this.page) + 1
            this.getSurahLoadMore(next_page)
        },
        setActive (menuItem) {
            this.activeTab = menuItem;
        },
        isActive (menuItem) {
            return this.activeTab === menuItem;
        },
        getShowPagination(type, urlPage) {
            let split = urlPage.split('=');
            let page = split[1];
            if(type == 1) {
                this.getPerAyat(page);
            } else {
                this.getPerKata(page);
            }
        },
        setPage(currentPage, type, status) {
            if(status) {
                if (type == "next"){
                    this.pageAyat = currentPage + 1;
                    this.getPerAyat(this.pageAyat);
                } else {
                    this.pageAyat = currentPage - 1;
                    this.getPerAyat(this.pageAyat);
                }
            }
        }
    },
    watch: {
        search(value) {
            if(this.surahs) {
                if(this.isBusy == false) {
                    this.isBusy = true
                    this.getSurah(value)
                        .then(() => {
                            this.isBusy = false
                        })
                }
            }
        }
    },
    computed: {
        ...mapState('quran', {
            surahs: state => state.surahs,
            page: state => state.page,
            next_page_url: state => state.next_page_url,
            show_per_ayat: state => state.show_per_ayat,
            show_per_kata: state => state.show_per_kata
        }),
        ...mapState([
            'terjemahan_bait', 'terjemahan_kata', 'harokat', 'detail'
        ])
    }
}
</script>

<style scoped>
.arab_count {
    padding : 1px;
    /* margin-bottom: 10px; */
}</style>
